export enum Sort {
  time,
  name,
  emoji,
}
